import { render } from "./DetailPageButtons.vue?vue&type=template&id=f8dc93e6&scoped=true"
import script from "./DetailPageButtons.vue?vue&type=script&lang=ts"
export * from "./DetailPageButtons.vue?vue&type=script&lang=ts"

import "./DetailPageButtons.vue?vue&type=style&index=0&id=f8dc93e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f8dc93e6"

export default script